
import React, { Component } from 'react';
import StockEditCategoryModal from './StockEditCategoryModal';
import { HelpBlock, Button, FormControl, Form, FormGroup, ControlLabel, Row, Col, Modal, ButtonToolbar, Tabs, Tab } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import Lightbox from 'react-images-extended';
import {Checkbox} from 'react-icheck'
import IframeModal from '../../component/element/IframeModal'
import StockStore from '../../stores/StockStore'
import PODocStore from '../../stores/PODocStore'
import AutopartStore from '../../stores/AutopartStore'
import Moment from 'moment';
import './Stock.css';
import No_img from '../../asset/img/no_image.jpg';
import {connect} from 'react-redux'
import CKAutocomplete from 'component/element/CKAutocomplete'
import ConfirmPopup from 'component/element/ConfirmPopup'
var NotificationSystem = require('react-notification-system');

class StockEditProductModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data:{},
      activeItemnum:0,
      formDisplay:'none',
      showCategoryPopup:false,
      optionsCategory:[],
      currentImage:0,
      lightboxIsOpen:false,
      checkLiquid:false,
      showLiquid:false,
      checkStockCard:false,
      partType:0,      
      displayPartType:this.props.tool==='part'?'none':'',
      formValid:'',
      validState:null,
      shop_list:'',
      shopList:[],
      tabSelect:'description',
      showReplacementConfirmDel:false,
      indexReplacementDel:null,
      showLocationConfirmDel:false,
      indexLocationDel:null,
      showLocationConfig:false,
      isSave:true
    }
    this.replacementInput = new Array(this.props.replacement).fill('')
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if (this.props.mode==='form')
      this.loadData()
  }

  componentWillReceiveProps(newProps){
    
  }

  loadData(){
    let newProps = this.props
    
    // if(newProps.dataSet.container_unit!==undefined && newProps.dataSet.container_unit!==''){
    //   this.setState({checkLiquid:true}) 
    // }

    if (newProps.dataSet.is_container==='0')
      this.setState({checkLiquid:false})
    else if (newProps.dataSet.is_container==='1')
      this.setState({checkLiquid:true})

    if (newProps.dataSet.is_stock_card==='0')
      this.setState({checkStockCard:false})
    else if (newProps.dataSet.is_stock_card==='1')
      this.setState({checkStockCard:true})  
    
    if(newProps.tool==='officemate' || newProps.tool==='color' || newProps.tool==='genpart'){
      this.setState({showLiquid:true})
    }
    if(newProps.tool==='part'&&newProps.show&&this.props.show!==newProps.show){
      let that = this
      StockStore.loadPartTypeInfo(newProps.dataSet.itemnum,newProps.dataSet.car_cat_id,function(result) {
        let data = Object.assign(newProps.dataSet,result.data[0])
        that.setState({data:data})
      })
    }
    this.loadShopList()
    this.loadCategory()
    if (newProps.dataSet.shop_list!=undefined) {
      let shop_lists = []
      let shop_list = ''
      if (newProps.dataSet.shop_list.length>0) {
        newProps.dataSet.shop_list.forEach((item,index)=>{
          if (item.shop_id!=undefined)
            shop_lists.push(item.shop_id)
          else
            shop_lists.push(item)
        })
        shop_list = shop_lists.join()
      }
      this.setState({shop_list:shop_list})
    }
    this.setState({data:newProps.dataSet})
  }

  getMonthNumber(txt) {
    let number = txt==='ม.ค.'?'01':txt==='ก.พ.'?'02':txt==='มี.ค.'?'03':txt==='เม.ย.'?'04':txt==='พ.ค.'?'05':txt==='มิ.ย.'?'06':txt==='ก.ค.'?'07':txt==='ส.ค.'?'08':txt==='ก.ย.'?'09':txt==='ต.ค.'?'10':txt==='พ.ย.'?'11':txt==='ธ.ค.'?'12':''
    return number
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      if (val==='0'||val===0)
        return ''
      else  
        return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2}) 
    }
    return ''
  }

  getLastImgKey(datas) {
    let dates = [], _dates = []
    datas.forEach((item,index)=>{
      let _date = item.createddate.split(" ")
      let day = _date[0]
      let month = this.getMonthNumber(_date[1])
      let year = _date[2]
      let time = _date[3]
      let date = year+'-'+month+'-'+day+' '+time
      const d = new Date(date);
      dates.push(d.getTime())
      _dates.push(d.getTime())
    })
    dates = dates.sort()
    let max = dates[dates.length-1]
    let key = _dates.indexOf(max)
    return key          
  }

  loadShopList() {
    let shopList = [] 
    PODocStore.loadSupplierList('','',(result) => {
      result.data.forEach((item,index)=>{  
        shopList.push({
          value: item.shop_id,
          label: item.name
        })
      })
      this.setState({shopList:shopList})
    })
  }  

  loadCategory() {
    let that = this
    StockStore.loadCategory(this.props.tool, function (result) {
      let dd = [{value:"",label:that.props.messages['Specify Category']}]
      result.data.forEach(function(item,index) {  
        dd.push({
          value: item.cat_id,
          label: item.name
        })
      })
      that.setState({optionsCategory:dd})
    })
  }

  onCategoryChange(e) {
    this.props.onCatChange(e.value)
  }

  onCategoryOpenClick() {
    this.setState({ showCategoryPopup: true })
  }

  onCategoryCloseClick() {
    this.setState({ showCategoryPopup: false })
  }

  onCategorySaveClick() {

    let data = this.refs.categoryPop.getWrappedInstance().getData()
    let that = this

    StockStore.saveCategory(this.props.tool, data, function (result) {
      let optionsCategory = result.data.map((item, index) => {
        return { value: item.cat_id, label: item.name }
      })

      optionsCategory.unshift({value:"",label:that.props.messages['Specify Category']})
      that.setState({ showCategoryPopup: false, optionsCategory: optionsCategory })
      if (that.props.onNewCategory !== undefined)
        that.props.onNewCategory()
    }, function () {
      that._notificationSystem.addNotification({
        title: that.props.messages['Notification'],
        message: that.props.messages['Save Category failed, Please Try Again.'],
        level: 'error',
        position: 'tc'
      });
    })

  }

  onUploadClick() {
    let {data} = this.state
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = 'https://demo2.bigfix.co/korat/fup/stock.html?cat=' + this.props.tool + '&itemnum=' + data.itemnum
    } else {
      url = './fup/stock.html?cat=' + this.props.tool + '&itemnum=' + data.itemnum
    }
    this.refs.iframe.loadUrl(url, ()=>{
      if (this.props.onImageUpload !== undefined)
        this.props.onImageUpload((result)=>{
          if (result.status==='OK') {
            if (result.data.length>0) {
              let key = this.getLastImgKey(result.data)
              if (key!=-1) {
                data.thumbnail_url = result.data[key].thumbnailUrl
                this.setState({data:data})
              }  
            }
          }
        })
    })
  }

  onImgClick() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: true,
    });
  }

  onTextChange(key, e) {
    let {data,partType} = this.state
    

    if(partType==='original'){
      
      data.original_info[key] = e.target.value
    }else if(partType==='similar'){
      
      data.similar_info[key] = e.target.value
    }else if(partType==='old'){
      
      data.old_info[key] = e.target.value
    }else{
      data[key] = e.target.value
    }
    this.setState({data:data})
  }

  onProductSaveClick() {
    let {data,shop_list,isSave} = this.state
    let {messages} = this.props
    if (isSave) {
      this.setState({isSave:false},()=>{
        if(data.description===''){
          this._notificationSystem.addNotification({
            title: messages['Notification'],
            message: messages['Enter Part Name'],
            level: 'error',
            position: 'tc'
          });
          this.setState({validState:'error',isSave:true})
          return
        }
        
        if (this.props.images.length>0) {
          data.thumbnail_url = this.props.images[this.getLastImgKey(this.props.images)].thumbnailUrl
          this.setState({data:data})
        }
        
        let that = this
        if (data.shop_list!==undefined) {
          if (shop_list!=='') {
            data.shop_list = shop_list.split(",")
          } else {
            data.shop_list = []
          }
        }
        let postData = data
        let new_cat = ""
        this.state.optionsCategory.forEach(function(item,index) {
          if (item.value===postData.cat_id) {
            new_cat = item.label
          }
        })
        
        if (this.props.tool==='part')
          postData = Object.assign({reference:'',special_quantity:'0',added_by:'',added_date:Moment().format("YYYY-MM-DD"),original_info:{barcode:'',cost_per_unit:'',location:'',price_per_unit:'',productcode:'',remark:''},similar_info:{barcode:'',cost_per_unit:'',location:'',price_per_unit:'',productcode:'',remark:''},old_info:{barcode:'',cost_per_unit:'',location:'',price_per_unit:'',productcode:'',remark:''},cat_id:postData.car_cat_id}, postData)
        else if (this.props.tool==='genpart')
          postData = {product:data,replacement:this.props.replacement,location_config:this.props.location_config,location:this.props.location,files:this.props.images}
        
        StockStore.saveProduct(this.props.tool, postData, function (result) {
          if (result.status === 'OK') { 
            if (data.itemnum!==undefined && data.itemnum>0) {
              let param = {key:'edit',value:data}
              postData['new_cat'] = new_cat
              if (that.props.updateData!==undefined)
                that.props.updateData(param)
              that.setState({isSave:true},()=>{
                if (result.closeOnSave) {
                  that.onModalHide()
                  // if (that.props.onReloadAfterSave!==undefined)
                  //   that.props.onReloadAfterSave(postData.product.description)
                }
              })  
            } else {
              postData['itemnum'] = result.id
              postData['added_date'] = Moment().format("YYYY-MM-DD")
              postData['new_cat'] = new_cat
              data.itemnum = result.id
              that.setState({data:data},()=>{
                let param = {key:'add',value:(that.props.tool==='genpart'?postData.product:postData)}
                if (that.props.updateData!==undefined) {
                  that.props.updateData(param,()=>{
                    if (result.closeOnSave) {
                      that.setState({isSave:true},()=>{
                        that.onModalHide()
                        // if (that.props.onReloadAfterSave!==undefined)
                        //   that.props.onReloadAfterSave(postData.product.description)
                      })
                    } else {
                      that.onModalHide(()=>{
                        that.setState({isSave:true})
                      })
                    }
                  })
                }
              })    
            }
            if (that.props.mixColorUpdateData!=undefined)
              that.props.mixColorUpdateData(result.data.product)
            
            that.setState({formValid:"",validState:null})
            that._notificationSystem.addNotification({
              title: 'แจ้งเตือน',
              message: messages['Save Item']+' [' + data.description + '] '+messages['Successfully'],
              level: 'info',
              position: 'tc'
            });
          }
        }, function () {
          that.setState({isSave:true})
          that._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: messages['Can Not Save Item, Please Try Again.'],
            level: 'error',
            position: 'tc'
          });
        })
      })  
    }  
  }

  onClickImage() {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.onClickNext()
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  onProductKeyPress(e) {
    if (e.charCode === 13) {
      //Do nothing
      e.preventDefault();
    }
    if (e.charCode === 13) {
      //alert('Enter... (KeyPress, use charCode)');
    }
    if (e.keyCode === 13) {
      //alert('Enter... (KeyDown, use keyCode)');
    }
  }

  onBarcodeKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
    }
  }

  onPartTypeChangeData(key,value) {
    let dataSet = {key:key,value:value}
    this.props.onTextChange(dataSet)
  }

  onPartTypeChange(e){
    this.setState({partType:e.value})
  }

  onCheckChange(){
    let {checkLiquid,data} = this.state
    if(checkLiquid){
      this.onTextChange('container_quantity',{target:{value:''}})
      this.onTextChange('container_unit',{target:{value:''}})
      data.is_container = '0'
    } else {
      data.is_container = '1'
      data = Object.assign({error_quantity:'',warning_quantity:'',quantity_per_container_unit:'',container_unit:'',container_quantity:''},data)
    }
    this.setState({checkLiquid:!checkLiquid,data:data})
  }

  onStockCardCheckChange() {
    let {checkStockCard,data} = this.state
    if (checkStockCard) {
      checkStockCard = false
      data.is_stock_card = '0'
    } else {
      checkStockCard = true
      data.is_stock_card = '1'
    }  
    this.setState({checkStockCard:checkStockCard,data:data})
  }

  renderImage() {
    let {messages} = this.props
    if (this.props.images.length > 0) {
      return (
        <Row>
          <Col xs={12}>
            <img src={this.props.images[this.getLastImgKey(this.props.images)].url} width="100%" height="100%" />
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col xs={6}>
            <img src={No_img} width="100%" height="100%" />
          </Col>
          <Col xs={6}>
            <h4 style={{ color: "#337ab7" }}>{messages['Product Image']}</h4>
            <h5>0 {messages['Image']}</h5>
          </Col>
        </Row>
      )
    }
  }

  onGenerateProductcodeClick(e) {
    let {tool} = this.props
    let {data,partType} = this.state
    
    StockStore.generateProductcode(tool,data.itemnum,partType,data.cat_id,(result)=>{
      let newDataSet = { key: 'productcode', value: result.productcode }
      data.productcode = result.productcode
      this.props.onTextChange(newDataSet)
      if (tool==='part') {
        if (partType==='original') {
          data.original_info.productcode = result.productcode
        } else if (partType==='similar') {
          data.similar_info.productcode = result.productcode
        } else if (partType==='old') {
          data.old_info.productcode = result.productcode
        }
        
      }
      this.setState({data:data})      
    })
  }

  onCopyProductCodeClick(e) {
    let {data,partType} = this.state
    let dataSet = { key: 'barcode', value: data.productcode }
    this.props.onTextChange(dataSet)
    data.barcode = data.productcode
    if (this.props.tool==='part') {
      
        if (partType==='original') {
          data.original_info.barcode = data.productcode
        } else if (partType==='similar') {
          data.similar_info.barcode = data.productcode
        } else if (partType==='old') {
          data.old_info.barcode = data.productcode
        }
       
    }
    this.setState({data:data})      
  }

  onModalHide(completeFunc=undefined) {
    if (this.props.tool==='part') {
      this.setState({partType:0, displayPartType:'none'}) 
    }
    if (completeFunc!==undefined) {
      setTimeout(()=>{
        completeFunc()
      },1000)
    } else
      this.props.onHide()
  }

  onShopChange(e) {
    let {shop_list} = this.state
    shop_list = e
    this.setState({shop_list:shop_list})
  }

  onTabsSelect(key) {
    this.setState({tabSelect:key})
  }

  onLocationChange() {
    let {tabSelect} = this.state
    let isLocation = this.props.dataSet.is_multiple_location
    if (isLocation==='1') {
      isLocation = '0'
      if (tabSelect==='location')
        tabSelect = 'description'
    } else 
      isLocation = '1'
    
    this.setState({tabSelect:tabSelect})
    if (this.props.onLocationChange!==undefined)
      this.props.onLocationChange(isLocation)
  }

  onReplacementChange() {
    let isReplacement = this.props.dataSet.has_replacement
    if (isReplacement==='1')
      isReplacement = '0'
    else 
      isReplacement = '1'
    
    if (this.props.onReplacementChange!==undefined)
      this.props.onReplacementChange(isReplacement)
  }

  onReplacementRowAdd(number=1) {
    let item = {bf_replacement_item_id:'',itemnum:'',productcode:'',description:'',brand:'',quantity:'',code_options:[]}
    if (this.props.onReplacementRowAdd!==undefined)
      this.props.onReplacementRowAdd(item)
  }

  onLocationRowAdd(number=1) {
    let item = {bf_location_item_id:'',location_config_id:null,location_name:'',quantity:'',seq:'',shelf_name:''}
    if (this.props.onLocationRowAdd!==undefined)
      this.props.onLocationRowAdd(item)
  }

  onLocationConfigRowAdd(number=1) {
    let item = {location_name:'',location_config_id:''}
    if (this.props.onLocationConfigRowAdd!==undefined)
      this.props.onLocationConfigRowAdd(item)
  }

  onActiveItem(itemnum){
    this.setState({activeItemnum:itemnum})        
  }

  renderReplacementRowData() {
    let {replacement} = this.props
    let checkHas = replacement.reduce((iitem,item,index)=>{
      if (typeof item.mark_to_delete==='undefined'||!item.mark_to_delete) {
        iitem.push(item)
      }
      return iitem
    },[])
    let data = replacement
    if (checkHas.length===0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      let i = 0
      return(
        data.map((item,index)=>{
          return(
            <tr key={index} style={{display:(item.mark_to_delete==='undefined'||!item.mark_to_delete?'':'none')}}>
              <td className='text-center tdReplacementProductcode'>
                {
                  (item.bf_replacement_item_id==undefined || item.bf_replacement_item_id==0)?(                
                  <CKAutocomplete
                    ref={(input) => { this.replacementInput[index] = input; }}
                    top='-35px'
                    items={item.code_options}
                    value={item.productcode}
                    onChange={this.onRowReplacementChange.bind(this,index,'productcode')}
                    onSelect={this.onRowReplacementSelect.bind(this,index,'productcode')}
                    onKeyPress={this.onRowReplacementSearchKeyPress.bind(this,index,'productcode')}
                    shouldItemRender={null}
                    boxWidthAuto={true}
                  />
                ):(
                  <span onClick={this.onActiveItem.bind(this,item.itemnum)}>{item.productcode}<FontAwesome name='search'/></span>
                  )
                }
              </td>
              <td className='text-left' onClick={this.onActiveItem.bind(this,item.itemnum)}>
                {item.description}
              </td>
              <td className='text-center'>
                {item.brand}
              </td>
              <td className='text-center'>
                {item.quantity}
              </td>
              <td className='text-center'>
                <Button bsStyle='danger' onClick={this.onRowReplacementDel.bind(this,index)}><FontAwesome name='trash' /> ลบ</Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderReplacement() {
    let {spec,messages} = this.props
    return(
      <div>
        <div>          
          <Row>
            <Col md={3} >
              <FormGroup>
                <ControlLabel>{messages['Spec Code']}</ControlLabel>
                {' '}
                <FormControl disabled={true} value={spec.productcode}/>
              </FormGroup>
            </Col>
            <Col md={6} >
              <FormGroup>
                <ControlLabel>{messages['Spec Description']}</ControlLabel>
                {' '}
                <FormControl disabled={true} value={spec.description}/>
              </FormGroup>
            </Col>
          </Row>
          <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
            <thead>
              <tr>
                <th className='text-center' style={{width:'150px'}}>หมายเลขอะไหล่</th>
                <th className='text-center' style={{width:'250px'}}>ชื่ออะไหล่</th>
                <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
                <th className='text-center' style={{width:'100px'}}>สต็อคคงเหลือ</th>
                <th className='text-center' style={{width:'50px'}}>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {this.renderReplacementRowData()}
            </tbody>
          </table>
        </div>
        <div>
          {this.renderReplacementNewItemButton()}
        </div>
      </div>
    )
  }

  renderReplacementNewItemButton(){
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onReplacementRowAdd.bind(this)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          </ButtonToolbar>   
        </Col>    
      </Row>
    )
  }

  onRowReplacementChange(index,field,e) {
    let val = e.target.value
    if (field==='productcode') {
      if (val.length>=3)
        this.onSearchProductCode(index,val)
      else if (val==='') {
        if (this.props.onRowReplacementChange!==undefined)
          this.props.onRowReplacementChange({field:'code_options',index:index,value:[]})
      }  
    }  
    
    let item = {field:field,index:index,value:val}
    if (this.props.onRowReplacementChange!==undefined)
      this.props.onRowReplacementChange(item)
  }

  onRowReplacementSelect(index,field,e,item_select) {
    let {replacement} = this.props
    if (field==='productcode') {
      let item = item_select  
      if (this.props.onRowReplacementChange!==undefined) {
        this.props.onRowReplacementChange({field:'itemnum',index:index,value:item.itemnum})
        this.props.onRowReplacementChange({field:'productcode',index:index,value:item.productCode})
        this.props.onRowReplacementChange({field:'description',index:index,value:item.detail})
        this.props.onRowReplacementChange({field:'brand',index:index,value:item.brand})
        this.props.onRowReplacementChange({field:'quantity',index:index,value:item.quantity})
      }  
      if(index===replacement.length-1) {
        if (this.props.onReplacementRowAdd!==undefined) {
          this.replacementInput[index+1] = ''
          this.props.onReplacementRowAdd({bf_replacement_item_id:'',itemnum:'',productcode:'',description:'',brand:'',quantity:'',code_options:[]},(result)=>{
            if (result==='OK') {
              this.replacementInput[index+1].onFocus()
            }  
          })
        }
      } else {
        this.replacementInput[index+1].onFocus()
      }
      if (this.props.onRowReplacementChange!==undefined)
        this.props.onRowReplacementChange({field:'code_options',index:index,value:[]})
    } else {
      if (this.props.onRowReplacementChange!==undefined)
        this.props.onRowReplacementChange({field:field,index:index,value:e})
    }
  }

  onRowReplacementSearchKeyPress(index,field,target) {
    let {replacement} = this.props
    if (target.charCode===13) {
      let that = this,foundIndex=-1
      this.setState({loading:false})
      let productCode = replacement[index][field]
      replacement.forEach((item,iindex)=>{
        if(item.productcode===productCode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0) {
        if (that.props.onRowReplacementChange!==undefined) {
          that.props.onRowReplacementChange({field:'quantity',index:foundIndex,value:replacement[foundIndex].quantity*1+1})
          that.props.onRowReplacementChange({field:'productcode',index:index,value:''})
        }  
        that.setState({loading:false})
      }else{
        AutopartStore.loadStockPartProductCode(productCode,function(result){
          if(result.data.length>0){
            let item = result.data[0]        
            if (that.props.onRowReplacementChange!==undefined) {
              that.props.onRowReplacementChange({field:'itemnum',index:index,value:item.itemnum})
              that.props.onRowReplacementChange({field:'productcode',index:index,value:item.productCode})
              that.props.onRowReplacementChange({field:'description',index:index,value:item.detail})
              that.props.onRowReplacementChange({field:'brand',index:index,value:item.brand})
              that.props.onRowReplacementChange({field:'quantity',index:index,value:item.quantity})
            }

            if(index===replacement.length-1){
              //End index
              if (that.props.onReplacementRowAdd!==undefined) {
                that.replacementInput[index+1] = ''
                that.props.onReplacementRowAdd({bf_replacement_item_id:'',itemnum:'',productcode:'',description:'',brand:'',quantity:'',code_options:[]})
              }
            }
            that.setState({loading:false})
            that.replacementInput[index+1].onFocus()
          }else{
            that._notificationSystem.addNotification({
              title:'แจ้งเตือน',
              message:'ไม่พบรายการรหัสสินค้า "'+productCode+'" ในคลังสินค้า',
              level:'error',
              position:'tc'
            });
            that.setState({loading:false})
          }
        })      
      }
    }
  }

  onRowReplacementDel(index) {
    let {replacement} = this.props
    if (replacement[index].bf_replacement_item_id!=='')
      this.setState({showReplacementConfirmDel:true,indexReplacementDel:index})
    else {
      if (this.props.onRowReplacementDel!==undefined)
        this.props.onRowReplacementDel(index)
    }  
  }

  onRowReplacementConfirmDel() {
    let index = this.state.indexReplacementDel
    this.setState({showReplacementConfirmDel:false,indexReplacementDel:null})
    if (this.props.onRowReplacementDel!==undefined)
      this.props.onRowReplacementDel(index)
  }

  onRowLocationDel(index) {
    let {location} = this.props
    if (location[index].bf_location_item_id!=='')
      this.setState({showLocationConfirmDel:true,indexLocationDel:index})
    else {
      if (this.props.onRowLocationDel!==undefined)
        this.props.onRowLocationDel(index)
    }  
  }

  onRowLocationConfigDel(index) {
    if (this.props.onRowLocationConfigDel!==undefined)
      this.props.onRowLocationConfigDel(index)
  }

  onRowLocationConfirmDel() {
    let index = this.state.indexLocationDel
    this.setState({showLocationConfirmDel:false,indexLocationDel:null})
    if (this.props.onRowLocationDel!==undefined)
      this.props.onRowLocationDel(index)
  }

  onLocationConfigOpen() {
    this.setState({showLocationConfig:true})
  }

  onRowLocationConfigChange(index,field,e) {
    let val = e.target.value
    let item = {field:field,index:index,value:val}
    if (this.props.onRowLocationConfigChange!==undefined)
      this.props.onRowLocationConfigChange(item)
  }

  onLocationConfigSave() {
    if (this.props.onLocationConfigSave!==undefined) {
      this.props.onLocationConfigSave()
      this.onLocationConfigHide()
    }
  }

  onLocationConfigHide() {
    this.setState({showLocationConfig:false})
  }
  
  onSearchProductCode(index,query) {
    AutopartStore.loadStockPartProductCode(query,(result)=>{
      let options = result.data.map((item,index)=>{
        return {
          id:item.itemnum,
          productCode:item.productcode,
          itemnum:item.itemnum,
          categoryName:item.cat_name,
          detail:item.description,
          pricePerUnit:item.price_per_unit,
          exportQuantity:item.quantity,
          costPerUnit:item.cost_per_unit,
          discountPercent:'0',
          discountAmount:'0',
          partFrom:'',
          label:item.productcode+' - '+item.description+(item.cat_name!==''&&item.cat_name!==null&&item.cat_name!==undefined?' (หมวด'+item.cat_name+')':''), // +(item.price_per_unit!==''&&item.price_per_unit!==null&&item.price_per_unit!==undefined?item.price_per_unit:'0')+' บาท '
          value:item.productcode,
          is_product_lot:item.is_product_lot,
          quantity:item.quantity,
          brand:item.brand
        }
      })
      let items = {field:'code_options',index:index,value:options}
      if (this.props.onRowReplacementChange!==undefined)
        this.props.onRowReplacementChange(items)
    })
  }

  onRowLocationChange(index,field,e) {
    let {dataSet,location} = this.props
    let item = {field:field,index:index,value:(field==='location_config_id'?(e===null?{label:'',value:'0'}:e):e.target.value)}
    if (field==='quantity') {
      let all_qty = 0
      let qty = (e.target.value===''||e.target.value===null||e.target.value===undefined||isNaN(e.target.value)?0:e.target.value)
      location.forEach((item,sindex)=>{
        if (sindex!==index)
          all_qty += (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity)*1
      })
      all_qty += (qty)*1
      if (all_qty>dataSet.quantity) {
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ขออภัย จำนวนไม่สามารถเกินกว่าจำนวนคงเหลือในคลัง',
          level: 'error',
          position: 'tc'
        });
        return false
      }
    }
    if (this.props.onRowLocationChange!==undefined)
      this.props.onRowLocationChange(item)
  }

  renderLocationRowData() {
    let {location,location_config} = this.props
    if (location.length===0) {
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    } else {
      let location_options = location_config.map((item,index)=>{
        return {label:item.location_name,value:item.location_config_id}
      })
      return(
        location.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-left'>
                <Select
                  clearable={true}
                  placeholder='เลือก'
                  options={location_options}
                  value={item.location_config_id}
                  onChange={this.onRowLocationChange.bind(this,index,'location_config_id')}
                />
              </td>
              <td className='text-center'>
                <FormControl value={item.shelf_name} onChange={this.onRowLocationChange.bind(this,index,'shelf_name')} />
              </td>
              <td className='text-center'>
                <FormControl className='text-center' value={item.quantity} onChange={this.onRowLocationChange.bind(this,index,'quantity')} />
              </td>
              <td className='text-center'>
                <Button bsStyle='danger' onClick={this.onRowLocationDel.bind(this,index)}><FontAwesome name='trash' /> ลบ</Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderLocation() {
    return(
      <div>
        <div>
          <Row>
            <Col lg={6} md={6} sm={4} xs={12} className='pull-right'>
              <Form horizontal>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={8}>
                    จำนวนคงเหลือ :
                  </Col>
                  <Col sm={4}>
                    <FormControl value={this.props.dataSet.quantity} className='text-right' placeholder='' readOnly={true} />
                  </Col>
                </FormGroup>
              </Form>  
            </Col>  
          </Row>    
        </div>
        <div className='table-responsive'>
          <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
            <thead>
              <tr>
                <th className='text-center' style={{width:'250px'}}>ชื่อคลังสินค้า <Button bsSize='xs' bsStyle='success' onClick={this.onLocationConfigOpen.bind(this)}><FontAwesome name='plus' /></Button></th>
                <th className='text-center' style={{width:'100px'}}>ชั้นวาง</th>
                <th className='text-center' style={{width:'100px'}}>จำนวน</th>
                <th className='text-center' style={{width:'50px'}}>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {this.renderLocationRowData()}
            </tbody>
          </table>
        </div>
        <div>
          {this.renderLocationNewItemButton()}
        </div>
      </div>
    )
  }

  renderLocationNewItemButton(){
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onLocationRowAdd.bind(this)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          </ButtonToolbar>   
        </Col>    
      </Row>
    )
  }

  renderDescription() {
    let showCat = (this.props.tool!=='part')
    let {data,checkLiquid,showLiquid,displayPartType,partType,checkStockCard} = this.state
    let {tool,messages} = this.props
    let displayForm = false
    let displayQuantity = "block"
    
    if(partType==='original'){
      displayPartType = 'block'
      data = Object.assign(data,data.original_info)
    }else if(partType==='similar'){
      displayPartType = 'block'
      data = Object.assign(data,data.similar_info)
    }else if(partType==='old'){
      displayPartType = 'block'
      data = Object.assign(data,data.old_info)
    }
    if (data.cat_id!==undefined&&data.cat_id!==''&&data.cat_id!==0) {
      displayForm = true
    }
    
    if(!showCat){
      displayForm = true
    }

    if (data.itemnum) {
      displayQuantity = ""
    }

    let displayCode = this.props.searchType=='freetext'?'none':'block'
    let displayPrice = "block"
    if (tool==="tool"||tool==="officemate") {
      displayPrice = "none"
    }

    if (tool==='part') {
      displayPrice = displayPartType
      displayCode = displayPartType
    }

    let displayNoticeQuantity = ''
    if (tool==='tool'||tool==='part') {
      displayNoticeQuantity = 'none'
    }
    let cQPCU = data.quantity_per_container_unit*1
    let cUnit = (data.container_unit!==''&&data.container_unit!==null&&data.container_unit!==undefined?data.container_unit:'หน่วยใหญ่')
    let cQuantity = data.is_container?(cQPCU>0?(this.getNumberFormat(data.quantity/cQPCU)):''):'';
    return(
          <div>
            <div style={{display:(displayForm)?'':'none'}}>
              <form style={{display:(this.props.searchType==='freetext')?'none':'block'}}>
                <Row>
                  <Col md={3} style={{display:displayQuantity}}>
                    <FormGroup>
                      <ControlLabel>{messages['Quantity']}</ControlLabel>
                      {' '}
                      <FormControl type="text" placeholder="" readOnly={data.itemnum>0} value={data.quantity} onChange={this.onTextChange.bind(this, 'quantity')} />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Unit']}</ControlLabel>
                      {' '}
                      <FormControl type="text" placeholder="" value={data.unit} onChange={this.onTextChange.bind(this, 'unit')} />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{ display: (!showCat)?'block':'none' }}>
                    <FormGroup controlId="formInlineName">
                      <ControlLabel>{messages['Parts Type']}</ControlLabel>
                      {' '}
                      <Select 
                        clearable={false}   
                        value={this.state.partType}                   
                        options={[{label:'--- '+messages['Select Type']+' ---',value:0},{label:messages['Original'],value:'original'},{label:messages['Similar'],value:'similar'},{label:messages['Old'],value:'old'}]}
                        onChange={this.onPartTypeChange.bind(this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{display:displayPartType}}>
                    <FormGroup controlId="formInlineName">
                      <ControlLabel>{data.unit!==''&&data.unit!==null&&data.unit!==undefined?'ราคาต้นทุน (ต่อ'+data.unit+')':messages['Cost']}</ControlLabel>
                      {' '}
                      <FormControl type="text" className="text-center" placeholder="x,xxx" value={data.cost_per_unit} onChange={this.onTextChange.bind(this, 'cost_per_unit')} />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{display:displayPrice}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Price']}</ControlLabel>
                      {' '}
                      <FormControl type="text" className="text-center" placeholder="x,xxx" value={data.price_per_unit} onChange={this.onTextChange.bind(this, 'price_per_unit')} />
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{display:(showLiquid)?'block':'none'}}>
                  <Col md={3}>
                        <Checkbox
                          onChange={this.onCheckChange.bind(this)}
                          checked={checkLiquid}
                          checkboxClass="icheckbox_square-blue"
                          increaseArea="20%"
                          label=" มีหน่วยใหญ่"
                        />
                        {' '}
                        <Checkbox
                          onChange={this.onStockCardCheckChange.bind(this)}
                          checked={checkStockCard}
                          checkboxClass="icheckbox_square-blue"
                          increaseArea="20%"
                          label=" มี Stock Card"
                        />
                  </Col>
                </Row>
                <Row style={{display:displayNoticeQuantity}}>
                  <Col md={2} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup>
                      <ControlLabel>{messages['Quantity']+' ('+cUnit+')'} </ControlLabel>
                      {' '}
                      <FormControl className='text-center' readOnly={true} placeholder="" value={cQuantity}  />
                    </FormGroup>
                  </Col>
                  <Col md={2} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Unit']+' ('+cUnit+')'}</ControlLabel>
                      {' '}
                      <FormControl type="text" placeholder="" value={data.container_unit} onChange={this.onTextChange.bind(this, 'container_unit')} />
                    </FormGroup>
                  </Col>
                  <Col md={2} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{'ปริมาตร(จำนวน) ต่อ'+cUnit}</ControlLabel>
                      {' '}
                      <FormControl className='text-center' placeholder="" value={data.quantity_per_container_unit} onChange={this.onTextChange.bind(this, 'quantity_per_container_unit')} />
                    </FormGroup>
                  </Col>  
                  <Col md={3} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineName">
                      <ControlLabel>{data.unit!==''&&data.unit!==null&&data.unit!==undefined?'ราคาต้นทุน (ต่อ'+cUnit+')':messages['Cost']}</ControlLabel>
                      {' '}
                      <FormControl type="text" className="text-center" readOnly={true} placeholder="x,xxx" value={data.cost_per_unit*cQPCU}  />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Price']}</ControlLabel>
                      {' '}
                      <FormControl type="text" className="text-center" readOnly={true} placeholder="x,xxx" value={data.price_per_unit*cQPCU} />
                    </FormGroup>
                  </Col>                
                </Row>
              </form> 
              <Row style={{display:displayNoticeQuantity}}>
                <Col md={3}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Order Notification']} ({data.unit})</ControlLabel>
                      {' '}
                      <FormControl className='text-center' placeholder="" value={data.warning_quantity} onChange={this.onTextChange.bind(this, 'warning_quantity')} />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Almost Out Notification']} ({data.unit})</ControlLabel>
                      {' '}
                      <FormControl className='text-center' placeholder="" value={data.error_quantity} onChange={this.onTextChange.bind(this, 'error_quantity')} />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Order Notification']} ({cUnit})</ControlLabel>
                      {' '}
                      <FormControl className='text-center' placeholder="" readOnly={true} value={this.getNumberFormat(data.warning_quantity/(cQPCU>0?cQPCU:1))} onChange={this.onTextChange.bind(this, 'warning_quantity')} />
                    </FormGroup>
                  </Col>
                  <Col md={3} style={{display:(checkLiquid && showLiquid)?'block':'none'}}>
                    <FormGroup controlId="formInlineEmail">
                      <ControlLabel>{messages['Almost Out Notification']} ({cUnit})</ControlLabel>
                      {' '}
                      <FormControl className='text-center' placeholder="" readOnly={true} value={this.getNumberFormat(data.error_quantity/(cQPCU>0?cQPCU:1))} onChange={this.onTextChange.bind(this, 'error_quantity')} />
                    </FormGroup>
                  </Col>
              </Row>           
              <Row>
                <Col md={8}>
                  <Row style={{display:displayCode}}>
                    <Col md={6}>
                        <FormGroup
                          controlId="formBasicText"
                        >
                          <ControlLabel>{messages['Product Code']} {' '} <Button bsStyle='link' onClick={this.onGenerateProductcodeClick.bind(this)}>{messages['Generate Code']}</Button></ControlLabel>
                          <FormControl type="text" placeholder="" value={data.productcode}
                            onKeyPress={this.onProductKeyPress.bind(this)}
                            onChange={this.onTextChange.bind(this, 'productcode')} />
                        </FormGroup>
                    </Col>
                    <Col md={6}>    
                        <FormGroup
                          controlId="formBasicText"
                        >
                          <ControlLabel>{messages['Barcode']} {' '} <Button bsStyle='link' onClick={this.onCopyProductCodeClick.bind(this)}>{messages['Copy From Product Code']}</Button></ControlLabel>
                          <FormControl type="text" placeholder="" value={data.barcode}
                            onChange={this.onTextChange.bind(this, 'barcode')} onKeyPress={this.onBarcodeKeyPress.bind(this)} />
                        </FormGroup>
                    </Col>
                  </Row>

                  <form style={{display:displayPartType}}>
                    <FormGroup
                      controlId="formBasicText"
                    >
                      <ControlLabel>{messages['Shelf']}</ControlLabel>
                      <FormControl type="text" placeholder="" value={data.location} onChange={this.onTextChange.bind(this, 'location')} />
                    </FormGroup>
                  </form>

                  <form style={{display:displayPartType}}>
                    <FormGroup
                      controlId="formBasicText"
                    >
                      <ControlLabel>{messages['Note']}</ControlLabel>
                      <FormControl type="text" placeholder="" value={data.remark} onChange={this.onTextChange.bind(this, 'remark')} />
                    </FormGroup>
                  </form>

                  <form style={{display:displayPartType}}>
                    <FormGroup
                      controlId="formBasicText"
                    >
                      <ControlLabel>{messages['Shop Order']}</ControlLabel>
                      <Select
                        multi={true}
                        removeSelected={false}
                        simpleValue={true}
                        clearable={false}
                        placeholder={messages['Select Shop Order']}
                        name="form-field-name"
                        value={this.state.shop_list}
                        options={this.state.shopList}
                        onChange={this.onShopChange.bind(this)}
                      />
                    </FormGroup>
                  </form>
                </Col>
                <Col md={4} style={{ display: (data.itemnum > 0) ? 'block' : 'none' }}>
                  <form style={{display:(this.props.searchType=='freetext')?'none':'block'}}>
                    <FormGroup
                      controlId="formBasicText"
                    >
                      <ControlLabel>{messages['Illustration']} <Button bsStyle='link' onClick={this.onUploadClick.bind(this)}>{messages['Upload']}</Button></ControlLabel>
                      <div className="box-up-img" style={{maxWidth:'320px'}} onClick={this.props.images.length>0?this.onImgClick.bind(this):()=>{}}>
                        <div style={{ padding: "5px" }}>
                          {this.renderImage()}
                        </div>
                      </div>
                    </FormGroup>
                  </form>
                </Col>
              </Row>
            </div>
          </div>
    )
  }

  renderMainBox() {
    let {messages,showLocation,showReplacement,stockType} = this.props
    let {data} = this.state
    return(
      <div>
                  <div id="product-main-box">   
                    <Row>
                      <Col md={3}>
                          <FormGroup
                            controlId="formBasicText"
                          >
                            <ControlLabel>{messages['Product Code']} {' '} <Button style={{lineHeight:'0px'}} bsStyle='link' onClick={this.onGenerateProductcodeClick.bind(this)}>{messages['Generate Code']}</Button></ControlLabel>
                            <FormControl type="text" placeholder="" value={data.productcode}
                              onKeyPress={this.onProductKeyPress.bind(this)}
                              onChange={this.onTextChange.bind(this, 'productcode')} />
                          </FormGroup>
                      </Col>
                      <Col md={8}>
                          <FormGroup
                          controlId={this.state.formValid}
                          validationState={this.state.validState}
                        >
                          <ControlLabel>{messages['Part Name']}</ControlLabel>
                          <FormControl type="text" placeholder="" value={data.description} onChange={this.onTextChange.bind(this, 'description')} />
                        </FormGroup>                      
                      </Col>
                    </Row>                 
                    {this.props.showProductOption && (
                    <FormGroup>
                      <span style={{display:(showLocation&&stockType==='genpart'?'':'none')}}>
                        <Checkbox
                          onChange={this.onLocationChange.bind(this)}
                          checked={this.props.dataSet.is_multiple_location==='1'?true:false}
                          checkboxClass="icheckbox_square-blue"
                          increaseArea="20%"
                          label=" เก็บหลายคลัง"
                        />
                        {' '}
                      </span>
                      <span style={{display:(showReplacement&&stockType==='genpart'?'':'none')}}>
                        <Checkbox
                          onChange={this.onReplacementChange.bind(this)}
                          checked={this.props.dataSet.has_replacement==='1'?true:false}
                          checkboxClass="icheckbox_square-blue"
                          increaseArea="20%"
                          label=" อะไหล่ทดแทน"
                        />
                      </span>
                    </FormGroup>)}
                  </div>
                  {((this.props.dataSet.is_multiple_location==='1'&&showLocation)&&stockType==='genpart')||
                  ((this.props.dataSet.has_replacement==='1'&&showReplacement)&&stockType==='genpart')
                  ?
                  <Tabs 
                    activeKey={this.state.tabSelect} 
                    animation={false} 
                    id="stock-lot-tabs"
                    onSelect={this.onTabsSelect.bind(this)}
                  >
                    {this.props.dataSet.is_multiple_location==='1'||this.props.dataSet.has_replacement==='1'?
                    <Tab 
                      eventKey={'description'}
                      title={'รายละเอียด'}
                    >
                      <br />
                      {this.renderDescription()}
                    </Tab>
                    :''}
                    {this.props.dataSet.is_multiple_location==='1'&&showLocation?
                    <Tab 
                      eventKey={'location'}
                      title={'คลังสินค้า'}
                    >
                      <br />
                      <div>{this.renderLocation()}</div>
                    </Tab>
                    :''}
                    {this.props.dataSet.has_replacement==='1'&&showReplacement?
                    <Tab 
                      eventKey={'replacement'}
                      title={'อะไหล่ทดแทน (Spec)'}
                    >
                      <br />
                      <div>{this.renderReplacement()}</div>
                    </Tab>
                    :''}
                  </Tabs>
                  :this.renderDescription()}
      </div>
    )
  }

  renderForm() {
    let {messages} = this.props
    let showCat = (this.props.tool!=='part')
    let {data} = this.state
    return(
      <div style={{maxWidth:'1200px',margin:'0 auto'}}>
            <form style={{display:(showCat)?'block':'none'}}>
              <FormGroup>
                <ControlLabel>{messages['Category']}</ControlLabel>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={data.cat_id===undefined?'':data.cat_id===0?'':data.cat_id}
                  options={this.state.optionsCategory}
                  onChange={this.onCategoryChange.bind(this)}
                />
                <FormControl.Feedback />
                <HelpBlock>
                  <Button
                    bsStyle={'box-tool'} className='btn-box-tool'
                    onClick={this.onCategoryOpenClick.bind(this)}
                  >
                    <FontAwesome name='plus' /> {messages['Add Category']}
                  </Button>
                </HelpBlock>
              </FormGroup>
            </form>
            {this.renderMainBox()}
      </div>
    )
  }

  renderLocationConfigModal() {
    let {showLocationConfig} = this.state
    let {messages,location_config} = this.props
    let checkHas = location_config.reduce((iitem,item,index)=>{
      if (typeof item.mark_to_delete==='undefined'||!item.mark_to_delete) {
        iitem.push(item)
      }
      return iitem
    },[])
    return(
        <Modal show={showLocationConfig} onHide={this.onLocationConfigHide.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>เพิ่มคลังสินค้า</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
                <thead>
                  <tr>
                    <th className='text-center' style={{width:'250px'}}>ชื่อคลังสินค้า</th>
                    <th className='text-center' style={{width:'50px'}}>ลบ</th>
                  </tr>
                </thead>
                <tbody>
                  {checkHas.length===0
                  ?
                  <tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>
                  :
                  location_config.map((item,index)=>{
                    return(
                      <tr key={index} style={{display:(item.mark_to_delete==='undefined'||!item.mark_to_delete?'':'none')}}>
                        <td className='text-left'>
                          <FormControl
                            value={item.location_name}
                            onChange={this.onRowLocationConfigChange.bind(this,index,'location_name')}
                          />
                        </td>
                        <td className='text-center'>
                          <Button bsStyle='danger' onClick={this.onRowLocationConfigDel.bind(this,index)}><FontAwesome name='trash' /> ลบ</Button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            {this.renderLocationConfigNewItemButton()}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-primary" onClick={this.onLocationConfigSave.bind(this)}>
              <FontAwesome name='save' /> {messages['Save']}
            </Button>
            <Button onClick={this.onLocationConfigHide.bind(this)}>
              <FontAwesome name='remove' /> {messages['Cancel']}
            </Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderLocationConfigNewItemButton(){
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onLocationConfigRowAdd.bind(this)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          </ButtonToolbar>   
        </Col>    
      </Row>
    )
  }

  render() {
    // let showCat = (this.props.tool!=='part')
    let images = this.props.images.map((item, index) => {
      return {
        src: item.url,
        thumbnail: item.thumbnailUrl,
        srcset: [
          item.url,
        ],
        caption: item.name
      }
    })

    // let {data,partType} = this.state
    let {messages,mode} = this.props
    let title = messages['Add Item']
    // let displayForm = false
    // let displayQuantity = "block"
    
    // if(partType==='original'){
    //   displayPartType = 'block'
    //   data = Object.assign(data,data.original_info)
    // }else if(partType==='similar'){
    //   displayPartType = 'block'
    //   data = Object.assign(data,data.similar_info)
    // }else if(partType==='old'){
    //   displayPartType = 'block'
    //   data = Object.assign(data,data.old_info)
    // }
    // if (data.cat_id!==undefined&&data.cat_id!==''&&data.cat_id!==0) {
    //   displayForm = true
    // }
    
    // if(!showCat){
    //   displayForm = true
    // }

    // if (data.itemnum) {
    //   title = messages['Edit Item']
    //   displayQuantity = "none"
    // }

    // let displayCode = this.props.searchType=='freetext'?'none':'block'
    // let displayPrice = "block"
    // if (tool==="tool"||tool==="officemate") {
    //   displayPrice = "none"
    // }

    // if (tool==='part') {
    //   displayPrice = displayPartType
    //   displayCode = displayPartType
    // }

    // let displayNoticeQuantity = ''
    // if (tool==='tool'||tool==='part') {
    //   displayNoticeQuantity = 'none'
    // }
    return(
      <div>
        {mode==='modal'?
        <Modal id="newStockPopup" bsSize="large" show={this.props.show} onShow={this.loadData.bind(this)} onHide={this.onModalHide.bind(this,undefined)} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={this.state.isSave?false:true} className="btn-primary" onClick={this.onProductSaveClick.bind(this)}>
              <FontAwesome name='save' /> {messages['Save']}
            </Button>
            <Button onClick={this.onModalHide.bind(this,undefined)}>
              <FontAwesome name='remove' /> {messages['Cancel']}
            </Button>
          </Modal.Footer>
        </Modal>
        :
        <Box>
          <Box.Body >
            {this.renderForm()}
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button disabled={this.state.isSave?false:true} className="btn-primary" onClick={this.onProductSaveClick.bind(this)}>
                <FontAwesome name='save' /> {messages['Save']}
              </Button>
              <Button onClick={this.onModalHide.bind(this,undefined)}>
                <FontAwesome name='close' /> {messages['Back']}
              </Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box>
        }
        <StockEditCategoryModal 
          ref='categoryPop'
          stockType={this.props.tool}  
          show={this.state.showCategoryPopup} 
          onHide={this.onCategoryCloseClick.bind(this)}
          onSaveClick={this.onCategorySaveClick.bind(this)}        
        />
        <IframeModal ref='iframe' title={messages['Upload Image']} modal={true} />
        <NotificationSystem ref="notificationSystem" />
        <Lightbox
          currentImage={this.state.currentImage}
          images={images}
          isOpen={this.state.lightboxIsOpen}
          rotatable={true}
          zoomable={true}          
          onClickImage={this.onClickImage.bind(this)}
          onClickNext={this.onClickNext.bind(this)}
          onClickPrev={this.onClickPrevious.bind(this)}
          onClose={this.onCloseLightbox.bind(this)}
        />
        <ConfirmPopup
          show={this.state.showReplacementConfirmDel}
          message='ยืนยันทำรายการลบหรือไม่ ?'
          onHide={()=>{this.setState({showReplacementConfirmDel:false,indexReplacementDel:null})}}
          onConfirm={this.onRowReplacementConfirmDel.bind(this)}
        />
        <ConfirmPopup
          show={this.state.showLocationConfirmDel}
          message='ยืนยันทำรายการลบหรือไม่ ?'
          onHide={()=>{this.setState({showLocationConfirmDel:false,indexLocationDel:null})}}
          onConfirm={this.onRowLocationConfirmDel.bind(this)}
        />
        {this.renderLocationConfigModal()}
      </div>
      // <div>
      //   <Modal bsSize="large" show={this.props.show} onHide={this.onModalHide.bind(this,undefined)}>
      //     <Modal.Header closeButton>
      //       <Modal.Title>{title}</Modal.Title>
      //     </Modal.Header>
      //     <Modal.Body>
            
      //     </Modal.Body>
      //     <Modal.Footer>
      //       <Button className="btn-primary" 
      //         style={{display:(displayForm)?'':'none'}}
      //         onClick={this.onProductSaveClick.bind(this)}>
      //         <FontAwesome name='save' /> {messages['Save']}
      //       </Button>
      //       <Button onClick={this.onModalHide.bind(this,undefined)}>
      //         <FontAwesome name='remove' /> {messages['Cancel']}
      //       </Button>
      //     </Modal.Footer>
      //   </Modal>
      // </div>
    )
  }
}

StockEditProductModal.defaultProps = {
  showCostPerUnitField:true,
  images:[],
  mode:'modal',
  location_config:[],
  spec:[]
}

export default connect(
  (state) => ({messages: state.message.view.stock.StockEditProductModal}),null,null,{withRef:true},
)(StockEditProductModal);





// WEBPACK FOOTER //
// ./src/view/stock/StockEditProductModal.js